
import { Link, useLocation } from "react-router-dom";
import { Home, Phone, MapPin, Recycle, Building, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";

const Taskbar = () => {
  const location = useLocation();
  
  const taskbarItems = [
    { name: "Accueil", path: "/", icon: Home },
    { name: "Contact", path: "/contact", icon: Phone },
    { name: "Sites", path: "/sites", icon: MapPin },
    { name: "Valorisation", path: "/valorisation/metaux-ferreux", icon: Recycle },
    { name: "Services", path: "/nos-services/location-bennes", icon: Building },
    { name: "Estimation", path: "/estimation-metaux", icon: Calculator },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg block md:hidden">
      <div className="flex justify-around items-center py-2 px-2">
        {taskbarItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path !== "/" && location.pathname.startsWith(item.path));
          
          return (
            <Link key={item.path} to={item.path} className="flex-1">
              <Button
                variant="ghost"
                size="sm"
                className={`w-full h-auto flex flex-col items-center justify-center py-2 px-1 ${
                  isActive 
                    ? "text-green-600 bg-green-50" 
                    : "text-gray-600 hover:text-green-600"
                }`}
              >
                <item.icon className="h-5 w-5 mb-1" />
                <span className="text-xs leading-tight">{item.name}</span>
              </Button>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Taskbar;
